<template>
  <div class="item">
    <div class="hd">
      {{ keys + 1 }} {{ item.FieldName }}
      <span v-if="item.Required" class="required">*</span>
    </div>
    <div class="bd">
      <!-- 判断题 单选题 -->
      <div v-if="item.QuestionType == 1 || item.QuestionType == 2">
        <!-- <div v-if="item.Options && item.Options.length > 4" class="zy-select">
          <select v-model="item.Answer" class="select">
            <option value="">请选择</option>
            <option
              v-for="item2 in item.Options"
              :key="item2.OptionId"
              :value="item2.OptionId"
            >
              {{ item2.OptionName }}
            </option>
          </select>
        </div> -->
        <van-radio-group v-model="item.Answer">
          <van-radio
            v-for="item2 in item.OptionList"
            :key="item2.OptionId"
            checked-color="#333"
            :name="item2.OptionId"
          >
            {{ item2.OptionName }}
          </van-radio>
        </van-radio-group>
      </div>

      <div v-if="item.QuestionType == 3">
        <van-checkbox-group v-model="item.answer">
          <div
            v-for="item2 in item.OptionList"
            :key="item2.OptionId"
            :class="{ 'has-input': item2.Input }"
          >
            <van-checkbox
              checked-color="#333"
              :class="{ 'no-margin': item2.Input }"
              :name="item2.OptionId"
              shape="square"
            >
              {{ item2.OptionName }}
            </van-checkbox>
          </div>
        </van-checkbox-group>
      </div>

      <!-- 数值题 -->
      <div v-if="item.QuestionType == 4" class="flex flex-align-center">
        <div class="flex-1 zy-input">
          <input
            v-model="item.Answer"
            class="text text-number zy-input-number"
            onkeyup="value = value.replace(/\D/g, '')"
            placeholder="请输入数值"
            type="number"
          />
        </div>
      </div>
      <!-- 填空题 -->
      <div v-if="item.QuestionType == 5">
        <div class="zy-input">
          <van-field
            v-model="item.Answer"
            autosize
            class="text"
            placeholder="请输入文字"
            rows="1"
            type="textarea"
          />
        </div>
        <!-- <div class="zy-input">
          <input
            v-model="item.Answer"
            class="text"
            placeholder="请输入文字"
            type="text"
          />
        </div> -->
      </div>

      <!-- 日期选择器 -->
      <div v-if="item.QuestionType == 6">
        <div class="zy-input">
          <van-cell is-link title="日期" @click="showCalendar = true">
            <template #value>
              {{ item.Answer }}
            </template>
          </van-cell>
        </div>
        <van-action-sheet v-model:show="showCalendar">
          <van-datetime-picker
            v-model="date"
            :min-date="minDate"
            title="选择日期"
            type="date"
            @cancel="showCalendar = false"
            @confirm="onConfirm"
          />
        </van-action-sheet>
      </div>
      <!-- 时间选择器 -->
      <div v-if="item.QuestionType == 7">
        <div class="zy-input">
          <van-cell
            is-link
            title="选择时间"
            :value="item.answer"
            @click="showTime = true"
          />
        </div>
        <van-action-sheet v-model:show="showTime">
          <van-datetime-picker
            v-model="item.answer"
            title="选择时间"
            type="time"
            @cancel="showTime = false"
            @confirm="onConfirmTime"
          />
        </van-action-sheet>
      </div>
      <div v-if="item.QuestionType == 8">
        <zy-upload
          v-model:file="item.answer"
          :disabled="preview"
          :limit-size="500 * 1024"
          :max-count="9"
          :max-size="10 * 1024 * 1024"
        />
      </div>
      <!-- 时间选择器 -->
      <div v-if="item.QuestionType == 9">
        <div class="zy-input">
          <van-cell
            is-link
            title="选择日期"
            :value="item.Answer"
            @click="showTime = true"
          >
            <template #value>
              <span v-if="!item.Answer" class="none">请选择</span>
              <span v-else>
                {{ item.Answer }}
              </span>
            </template>
          </van-cell>
        </div>
        <van-action-sheet v-model:show="showTime">
          <van-datetime-picker
            v-model="date"
            :max-date="maxDate"
            :min-date="minDate"
            title="选择日期"
            :type="item.QuestionType == 6 ? 'date' : 'datetime'"
            @cancel="showTime = false"
            @confirm="onConfirmTime"
          />
        </van-action-sheet>
      </div>
      <div v-if="item.QuestionType == 10">
        <SelectArea v-model:data="item.Answer" />
      </div>
    </div>
  </div>
</template>
<script>
  import SelectArea from '@/components/SelectArea/SelectArea.vue'
  import ZyUpload from '@/components/ZyUploader'
  import { dateFormat } from '@/utils/filters.js'
  export default {
    name: 'QuestionItem',
    components: {
      SelectArea,
      ZyUpload,
    },
    props: {
      item: {
        type: Object,
        default: () => {
          return {}
        },
      },
      keys: {
        type: Number,
        default: 0,
      },
      preview: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showTime: false,
        showCalendar: false,
        showPicker: false,
        fileList: [],
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(2100, 0, 31),
        date: this.item.Answer ? new Date(this.item.Answer) : new Date(),
      }
    },
    computed: {
      // getDefalutDate() {
      //   return new Date(this.item.Answer) || new Date()
      // },
    },
    methods: {
      onConfirmTime(value) {
        this.showTime = false
        this.item.Answer = dateFormat(value, 'yyyy-MM-dd hh:mm:ss')
      },
      onConfirm(value) {
        this.showCalendar = false
        this.item.Answer = dateFormat(value, 'yyyy-MM-dd')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .item {
    .hd {
      font-size: 18px;
      margin: 0 0 10px;
      color: #333;
      font-weight: 500;
    }
    .list-item {
      line-height: 1.6;
    }
    .van-radio,
    .van-checkbox {
      padding: 13px 16px;
      margin-bottom: 10px;
      border: 1px solid #dde5ed;
      border-radius: 4px;
    }
  }
  .required {
    color: #f00;
    font-family: 'Courier New', Courier, monospace;
  }
  .zy-input-number {
    height: 26px;
  }
</style>
